import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

export const SesionExpiradaDialog = ({ userName, onRelogin, onIrALogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);

  const entrar = async () => {
    if (!password) return;
    setCargando(true);
    setError('');
    const r = await onRelogin(password);
    setCargando(false);
    if (!r.success) setError(r.error || 'Credenciales incorrectas');
  };

  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent className="max-w-sm [&>button]:hidden" data-testid="sesion-expirada-dialog">
        <DialogHeader>
          <DialogTitle>🔒 Tu sesión ha vencido</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-[var(--text-muted)]">
          Inicia sesión nuevamente para continuar. <b>No te preocupes: lo que estabas escribiendo sigue guardado en pantalla</b> y podrás volver a presionar Guardar.
        </p>
        <div className="space-y-2">
          <Input value={userName || ''} disabled className="bg-[var(--bg)]" data-testid="sesion-expirada-usuario" />
          <Input type="password" value={password} autoFocus placeholder="Contraseña"
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && entrar()}
            data-testid="sesion-expirada-password" />
          {error && <p className="text-xs text-red-500 font-bold" data-testid="sesion-expirada-error">{error}</p>}
          <Button onClick={entrar} disabled={cargando || !password}
            className="w-full bg-[#6C3FB5] hover:bg-[#4B1D73] text-white font-bold"
            data-testid="sesion-expirada-entrar">
            {cargando ? 'Entrando…' : 'Iniciar sesión y continuar'}
          </Button>
          <button onClick={onIrALogin} className="w-full text-[11px] text-[var(--text-muted)] underline" data-testid="sesion-expirada-otra-cuenta">
            Entrar con otra cuenta
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
